/* Time is evaluated in the fulfilment timezone, not the customer's timezone. */
function sensoryDeliveryMessage(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Bucharest', weekday: 'short', hour: '2-digit', hourCycle: 'h23'
  }).formatToParts(date);
  const day = parts.find((part) => part.type === 'weekday').value;
  const hour = Number(parts.find((part) => part.type === 'hour').value);
  if (day === 'Sat' || day === 'Sun' || (day === 'Fri' && hour >= 16)) {
    return { state: 'soon', text: 'Comandă acum → expediere luni' };
  }
  if (day === 'Fri') return { state: 'urgent', text: 'Comandă până la 16:00 → livrare luni' };
  if (hour >= 16) return { state: 'soon', text: 'Comandă acum → expediere mâine' };
  return { state: 'urgent', text: 'Comandă până la 16:00 → livrare mâine' };
}

if (!customElements.get('product-delivery')) {
  class ProductDelivery extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.variantId = Number(this.dataset.variantId);
      this.text = this.querySelector('[data-delivery-text]');
      this.section = this.closest('.cc-main-product');
      this.changeHandler = (event) => { this.variantId = event.detail.variant?.id; this.update(); };
      this.refreshHandler = () => this.update();
      this.section.addEventListener('on:variant:change', this.changeHandler);
      document.addEventListener('visibilitychange', this.refreshHandler);
      this.timer = window.setInterval(this.refreshHandler, 30000);
      this.update();
    }

    update() {
      const variant = this.variants.find((entry) => entry.id === this.variantId);
      // An available backorder/preorder must not inherit an in-stock delivery promise.
      const eligible = variant?.available && (!variant.managed || variant.quantity > 0) && this.dataset.preorder !== 'true';
      this.hidden = true;
      this.text.textContent = '';
      if (!eligible) return;
      try {
        const message = sensoryDeliveryMessage();
        this.dataset.state = message.state;
        this.text.textContent = message.text;
        this.hidden = false;
      } catch (_) { /* Leave hidden if the browser cannot resolve the timezone. */ }
    }

    disconnectedCallback() {
      this.section?.removeEventListener('on:variant:change', this.changeHandler);
      document.removeEventListener('visibilitychange', this.refreshHandler);
      window.clearInterval(this.timer);
    }
  }
  customElements.define('product-delivery', ProductDelivery);
}
